import { SvgAttr as SvgAttribute } from '../utils/icon.interface';

export const COLOR_THEME_MAP = {
  whiteOnPrimary: {
    textColor: 'fill-white',
    backgroundColor: 'fill-primary-700',
  },
  primaryOnWhite: {
    textColor: 'fill-primary-700',
    backgroundColor: 'fill-white',
  },
  primaryOnGray: {
    textColor: 'fill-primary-700',
    backgroundColor: 'fill-gray-200',
  },
  blackOnGray: {
    textColor: 'fill-gray-900',
    backgroundColor: 'fill-gray-200',
  },
  blackOnWhite: {
    textColor: 'fill-gray-900',
    backgroundColor: 'fill-white',
  },
  whiteOnBlock: {
    textColor: 'fill-white',
    backgroundColor: 'fill-gray-900',
  },
};

type QogitaLogoContainedProps = SvgAttribute & {
  /**
   * 'whiteOnPrimary': White text with indigo background
   *
   * 'primaryOnWhite': Indigo text with white background
   *
   * 'primaryOnGray': Indigo text with gray background
   *
   * 'blackOnGray': Black text with gray background
   *
   * 'blackOnWhite': Black text with white background
   *
   * 'white-on-black': White text with black background
   */
  theme: keyof typeof COLOR_THEME_MAP;
};

export function QogitaLogoContained({
  theme,
  ...props
}: QogitaLogoContainedProps) {
  const selectedTheme = COLOR_THEME_MAP[theme];

  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 126 44">
      <title>Qogita</title>

      <path
        className={selectedTheme.backgroundColor}
        d="M22.19 44C9.951 44 0 34.132 0 22.006 0 9.879 9.957 0 22.19 0h81.621C116.048 0 126 9.87 126 22c0 12.132-9.957 21.995-22.189 21.995L22.189 44Z"
      />

      <path
        className={selectedTheme.textColor}
        d="M115.517 27.274c-.606 0-.91-.345-.91-1.032v-6.355c0-2.13-.616-3.756-1.849-4.877s-2.91-1.682-5.031-1.682c-1.385 0-2.558.223-3.521.67a6.21 6.21 0 0 0-2.301 1.749 7.035 7.035 0 0 0-1.245 2.388l3.765 1.34a3.551 3.551 0 0 1 .966-1.907c.498-.493 1.255-.739 2.272-.738 1.039 0 1.796.257 2.271.771.476.517.674 1.177.715 1.977.021.42-.16.961-1.306.961h-3.113a8.199 8.199 0 0 0-3.228.601 4.898 4.898 0 0 0-2.206 1.787c-.531.791-.796 1.77-.796 2.937 0 1.167.265 2.157.796 2.972a5.075 5.075 0 0 0 2.157 1.856 7.222 7.222 0 0 0 3.083.635c1.12 0 2.516-.173 3.165-.515.649-.343 1.12-.738 1.428-1.187.244-.33.446-.695.599-1.083.164-.42.308-.848.431-1.284h.373s-.052.41-.097 1.17c0 .686.05 1.187.527 1.65.476.462.927.616 1.728.616H116v-3.427l-.483.007Zm-4.868-3.163c0 1.123-.363 2.022-1.088 2.698-.726.676-1.659 1.013-2.8 1.013-.867 0-1.527-.194-1.98-.584a1.842 1.842 0 0 1-.512-.67 1.944 1.944 0 0 1-.17-.841 1.773 1.773 0 0 1 .155-.808 1.68 1.68 0 0 1 .495-.636c.432-.342 1.027-.514 1.784-.514h4.122l-.006.342ZM93.068 18.06H98v-3.518h-4.932V9.328h-4.571v5.214H84v3.519h4.497v9.48c0 1.15.371 2.07 1.113 2.757.742.689 1.701 1.032 2.877 1.03h5.078V27.81h-3.479c-.677 0-1.014-.34-1.014-1.017l-.004-8.731ZM81.436 14.252h-4.194v16.495h4.194V14.252ZM79.339 7.001a2.698 2.698 0 0 0-1.916.733c-.52.487-.782 1.13-.782 1.929-.001.799.26 1.441.782 1.928a2.888 2.888 0 0 0 3.845 0c.51-.488.766-1.13.766-1.928s-.255-1.441-.766-1.93a2.682 2.682 0 0 0-1.93-.732ZM69.724 13.806v.65c0 1.21.327 1.6.488 1.833l-.326.253s-1.016-1.071-1.228-1.329c-.414-.486-.816-.757-1.312-1.074-.82-.52-1.985-.81-3.553-.81-1.36-.011-2.7.333-3.88.998a7.426 7.426 0 0 0-2.844 2.878c-.714 1.253-1.07 2.76-1.069 4.52v.543c0 1.76.356 3.267 1.069 4.52a7.426 7.426 0 0 0 2.844 2.878 7.782 7.782 0 0 0 3.88 1c1.059 0 1.932-.124 2.62-.372a4.974 4.974 0 0 0 1.656-.932c.185-.154.355-.325.51-.51.211-.259 1.233-1.349 1.233-1.349l.326.26c-.161.231-.483.622-.483 1.832v1.993c0 .676-.322 1.014-.965 1.014h-7.788v3.726h9.305c1.147 0 2.066-.344 2.758-1.033.693-.688 1.038-1.608 1.035-2.759v-18.73h-4.276Zm0 8.364c0 1.512-.448 2.686-1.345 3.52-.897.836-2.012 1.254-3.345 1.255-1.333 0-2.448-.418-3.344-1.254-.896-.836-1.345-2.01-1.345-3.52v-.338c0-1.536.448-2.716 1.345-3.54.897-.825 2.012-1.237 3.344-1.237 1.357 0 2.478.412 3.363 1.236.886.825 1.327 2.005 1.323 3.54l.004.338ZM49.603 14.357c-1.362-.685-2.897-1.028-4.604-1.029-1.707 0-3.241.342-4.604 1.03a7.767 7.767 0 0 0-3.217 2.988C36.394 18.653 36 20.222 36 22.053v.55c0 1.833.393 3.402 1.178 4.705a7.766 7.766 0 0 0 3.217 2.99c1.363.687 2.897 1.03 4.604 1.03 1.707 0 3.242-.343 4.604-1.03a7.762 7.762 0 0 0 3.22-2.99C53.606 26.005 54 24.435 54 22.602v-.55c0-1.831-.393-3.4-1.178-4.706a7.762 7.762 0 0 0-3.219-2.989Zm.036 8.143c0 1.604-.439 2.834-1.317 3.69-.878.855-1.985 1.285-3.32 1.288-1.339 0-2.445-.43-3.32-1.288-.875-.86-1.313-2.09-1.315-3.69v-.343c0-1.603.439-2.833 1.315-3.69.877-.858 1.983-1.287 3.32-1.288 1.362 0 2.475.43 3.34 1.288.865.858 1.298 2.088 1.3 3.69l-.003.343ZM34.566 31.207a10.916 10.916 0 0 0-4.53-2.73l.136-.454a2.248 2.248 0 0 0 2.039-.497c1.16-1.045 1.96-3.481 1.96-6.065a12.202 12.202 0 0 0-1.196-5.24 12.151 12.151 0 0 0-3.328-4.21 12.059 12.059 0 0 0-10.163-2.403c-4.56.96-8.246 4.664-9.205 9.243a12.208 12.208 0 0 0 2.392 10.212 12.115 12.115 0 0 0 4.197 3.343 12.064 12.064 0 0 0 5.221 1.198c2.79 0 4.724-.818 5.738-1.729 1.014-.91.926-2.436.926-2.436l.404-.095.021.067c.53 1.666 1.45 3.18 2.682 4.416l2.481 2.501L37 33.658l-2.434-2.451ZM22.09 29.263a7.739 7.739 0 0 1-4.312-1.314 7.788 7.788 0 0 1-2.858-3.498 7.826 7.826 0 0 1 1.683-8.495 7.732 7.732 0 0 1 8.459-1.69 7.769 7.769 0 0 1 3.483 2.87 7.82 7.82 0 0 1-.967 9.841 7.753 7.753 0 0 1-5.488 2.286Z"
      />
    </svg>
  );
}
